import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface KnowledgeGetFolderItemsResponse {
  folders: number;
  items: KnowledgeItems[];
  page: number;
  size: number;
};

export interface KnowledgeItems {
  id: number;
  folder_id: number;
  user_id: number;
  is_enabled: number;
  item_type: number;
  vector_library_id?: string;
  vector_library_file_url?: string;
  create_time: string;
  update_time: Date;
  deleted_time?: string;
  item_detail: Array<ItemDetail>;
};

export interface ItemDetail {
  id: number;
  knowledge_folder_item_id: number;
  content_title: string;
  item_url: string;
  item_content?: string;
  is_enabled: number;
  vector_library_id?: string;
  vector_library_file_url?: string;
  width: number;
  height: number;
  duration: number;
  fps: number;
  size: number;
  vector_ids?: string[];
  use_mark_value?: string;
  use_sub_mark_values?: string[];
  task_id?: string;
  n8n_task_id?: string;
  task_status?: string;
  create_time: Date;
  update_time: Date;
  deleted_time?: string;
};

// 文件详情数据
export class ItemDetailData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Content title cannot be empty")
  @IsString("Content title must be a string")
  contentTitle: string;

  @IsString("Item content must be a string")
  itemContent?: string;

  @Required("Item url cannot be empty")
  @IsString("Item url must be a string")
  itemUrl: string;

  @Required("Create time cannot be empty")
  @IsString("Create time must be a string")
  createTime: string
  
  @Required("Item type cannot be empty")
  @IsString("Item type must be a string")
  itemType?: string;

  @IsNumber("Parent id must be a number")
  parentId?: number;

  itemDetail?: ItemDetailData[];
}

export class KnowledgeItemsData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @IsString("Create time must be a string")
  createTime: string;

  @IsString("Item type must be a string")
  itemType: string;

  @Required("Item detail cannot be empty")
  itemDetail?: ItemDetailData[];
}

export class KnowledgeGetFolderItemsData {
  @Required("Items cannot be empty")
  @IsArray("Items must be an array")
  items: KnowledgeItemsData[];
}

const transformAndValidateAgent = (
  response: KnowledgeGetFolderItemsResponse
): KnowledgeGetFolderItemsData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KnowledgeGetFolderItemsData);
  } catch (error) {
    console.error("User material list folders data validation failed:", error.message);
    throw error;
  }
};

/** 知识库文件夹列表项 */
export const knowledgeGetFolderItems = async (folderId: number): Promise<KnowledgeGetFolderItemsData> => {
  const response = await api.post<KnowledgeGetFolderItemsResponse>('/knowledge/get_folder_items', {
    folder_id: folderId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
